import { MiModal } from "@miplatform/components";
import {
  BUTTON_COLORS,
  BUTTON_VARIANTS,
  TYPOGRAPHY_VARIANTS,
} from "@miplatform/constants";
import { mdiCheck } from "@mdi/js";
import { Typography, useTheme } from "@mui/material";

interface NhcForceCompleteOrderModalProps {
  open: boolean;
  onClose: () => void;
  onForceComplete: () => Promise<void>;
  isLoading: boolean;
}

export const NhcForceCompleteOrderModal = ({
  open,
  onClose,
  onForceComplete,
  isLoading,
}: NhcForceCompleteOrderModalProps) => {
  const theme = useTheme();

  const handleSubmit = async () => {
    await onForceComplete();
  };

  return (
    <MiModal
      open={open}
      closeModal={onClose}
      width={330}
      titleIcon={mdiCheck}
      leftIconColor={theme.palette.primary.main}
      title="Force Complete Order"
      loading={isLoading}
      actions={[
        {
          name: "Close",
          variant: BUTTON_VARIANTS.TEXT,
          color: BUTTON_COLORS.BLACK,
          onClick: onClose,
        },
        {
          name: "Force Complete Order",
          variant: BUTTON_VARIANTS.CONTAINED,
          disabled: isLoading,
          onClick: handleSubmit,
        },
      ]}
    >
      <Typography
        variant={TYPOGRAPHY_VARIANTS.SUBTITLE2}
        color="grey"
        mb={2}
        px={2}
      >
        Force completing an order indicates that the work is finished.
      </Typography>
    </MiModal>
  );
};
